import {
	autoOpenLauncherAfterSeconds,
	trackLauncherOnPageAfterSeconds,
} from '@bark/bark-core';

import { _t, momentLocale, reloadMomentLocale } from '@bark/bark-core';

const moment = momentLocale();

import {SuspendedSellerCheck, triggerEnquiriesBanner} from '../components';
export default function () {
	try {
		window.onload = () => {
			trackLauncherOnPageAfterSeconds(5);
			autoOpenLauncherAfterSeconds(5);
		};
	} catch (e) {
		console.log(e);
	}

	SuspendedSellerCheck();
	init();
}

export function LegacyHomePage() {
	const { Handlebars } = window;

	moment.defineLocale('en', {
		relativeTime: {
			future: 'in %s',
			past: '%s',
			s: 'now',
			ss: '%ds',
			m: '1m',
			mm: '%dm',
			h: '1h',
			hh: '%dh',
			d: '1d',
			dd: '%dd',
			M: '1mo',
			MM: '%dmo',
			y: '1y',
			yy: '%dy',
		},
	});

	//Reload the locale since adjusting above resets the current locale to EN
	// the adjustment above is specific to this file and hence cannot be pulled to core
	reloadMomentLocale(moment);

	Handlebars.registerHelper('pluralize', function (number, singular, plural) {
		if (number === 1) return singular;
		else return typeof plural === 'string' ? plural : singular + 's';
	});

	Handlebars.registerHelper('pluralCount', function (number, singular, plural) {
		return number + ' ' + Handlebars.helpers.pluralize.apply(this, arguments);
	});

	function processTemplate(
		targetElement,
		templateId,
		apiEndpoint,
		mappingFunction,
		successCallback,
		failureCallback,
	) {
		var handlebarsTemplate;
		Bark.api(
			apiEndpoint,
			{},
			function (data) {
				if (typeof data.status === 'undefined' || data.status) {
					if (typeof successCallback !== 'undefined') {
						successCallback(data);
					} else {
						targetElement.html(handlebarsTemplate(mappingFunction(data)));
					}
				} else {
					if (typeof failureCallback !== 'undefined') {
						failureCallback(data);
					}
				}
			},
			function (data) {
				if (typeof failureCallback !== 'undefined') {
					failureCallback(data);
				}
			},
			'GET',
			Bark.apiVersionHeader('v2'),
		);
		handlebarsTemplate = Handlebars.compile($('#' + templateId).html());
	}

	function handleSignupMessages() {
		// If the project they signed up for is no longer available, remove the sticky project
		if (Bark.getUrlParam('notavailable') > 0) {
			Bark.json({
				url: '/sellers/remove_sticky_project/',
				type: 'get',
			}).done(function () {
				// do nothing
			});
		}
	}

	function homeLeadsStatus() {
		processTemplate(
			$('.js-leads-stats'),
			'hbt-home-leads-stats',
			'seller/stats/leads',
			function (data) {
				data = data.data;
				$('.js-live-current').text(
					_t(
						'seller_homepage:your-account-section.lead-preferences-subsection.live-stats.total',
						{
							count: data.total_leads,
						},
					),
				);

				if (parseInt(data.total_leads) < 1) {
					$('.js-live-current-container').each(function () {
						$(this).addClass('d-none');
						$(this).removeClass('d-flex');
					});
					$('.js-live-current-container-noleads').each(function () {
						$(this).removeClass('d-none');
						$(this).addClass('d-flex');
					});
				} else {
					$('.js-live-current-container').each(function () {
						$(this).removeClass('d-none');
						$(this).addClass('d-block');
					});
					$('.js-live-current-container-noleads').each(function () {
						$(this).addClass('d-none');
						$(this).removeClass('d-flex');
					});
				}
				if (data.leads_per_day) {
					var day = Math.round(data.leads_per_day);
					var week = Math.round(data.leads_per_week);
					if (day < 2) {
						$('.js-live-prediction').text(week > 1 ? week : '<1');
						$('.js-live-prediction-per').text(
							_t(
								'seller_homepage:your-account-section.lead-preferences-subsection.live-stats.interval.week',
							),
						);
						$('.js-live-stats-pd').removeClass('d-none');
					} else {
						$('.js-live-prediction').text(day);
						$('.js-live-prediction-per').text(
							_t(
								'seller_homepage:your-account-section.lead-preferences-subsection.live-stats.interval.day',
							),
						);
						$('.js-live-stats-pd').removeClass('d-none');
					}
				} else {
					$('.js-live-stats-pd').addClass('d-none');
				}
				return {
					unread: data.unread,
					total_leads: data.total_leads,
					total_leads_noun: _t('seller_homepage:your-account-section.leads.leads', {
						count: data.total_leads,
					}),
					unread_large: 99 < data.unread,
					unread_leads_noun: _t('seller_homepage:your-account-section.unread-lead', {
						lead: _t('seller_homepage:your-account-section.leads.leads', {
							count: data.total_leads,
						}).toLowerCase(),
					}),
					large: 99 < data.total_leads,
				};
			},
		);
	}

	function homeResponsesStatus() {
		processTemplate(
			$('.js-response-stats'),
			'hbt-home-response-stats',
			'seller/stats/responses',
			function (data) {
				data = data.data;
				return {
					total_responses: data.sub_stats.total_responses,
					projects_pending: data.sub_stats.projects_pending,
					projects_pending_time_ago: data.sub_stats.projects_pending_time_ago
						? moment
							.unix(data.sub_stats.projects_pending_time_ago / 1000)
							.utc()
							.fromNow()
						: '',
					unread_messages: data.sub_stats.unread_messages,
					unread_messages_time_ago: data.sub_stats.unread_messages_time_ago
						? moment
							.unix(data.sub_stats.unread_messages_time_ago / 1000)
							.utc()
							.fromNow()
						: '',
					outstanding_quotes: data.sub_stats.outstanding_quotes,
					outstanding_quotes_time_ago: data.sub_stats.outstanding_quotes_time_ago
						? moment
							.unix(data.sub_stats.outstanding_quotes_time_ago / 1000)
							.utc()
							.fromNow()
						: '',
					contact_requests: data.sub_stats.contact_requests,
					contact_requests_time_ago: data.sub_stats.contact_requests_time_ago
						? moment
							.unix(data.sub_stats.contact_requests_time_ago / 1000)
							.utc()
							.fromNow()
						: '',
					unread_total: data.sub_stats.unread_messages,
					unread_large: 99 < data.sub_stats.unread_messages,
					large: 99 < data.sub_stats.total_responses,
					responses_noun: _t('seller_homepage:your-account-section.responses.responses', {
						count: data.sub_stats.total_responses,
					}),
					unread_total_text: _t(
						'seller_homepage:your-account-section.unread-message-and-request.unread-message-and-request',
						{ count: data.sub_stats.unread_messages },
					),
				};
			},
		);
	}

	function homeUpdatesLatest() {
		var monthNames = [
			_t('common:jan_full'),
			_t('common:feb_full'),
			_t('common:mar_full'),
			_t('common:apr_full'),
			_t('common:may_full'),
			_t('common:jun_full'),
			_t('common:jul_full'),
			_t('common:aug_full'),
			_t('common:sep_full'),
			_t('common:oct_full'),
			_t('common:nov_full'),
			_t('common:dec_full'),
		];
		processTemplate(
			$('.js-home-updates-short'),
			'hbt-home-updates-short',
			'seller-comms/updates/?limit=2',
			function (data) {
				data = data.data.updates;
				var updates = [];
				var unseen_ids = [];
				for (var i = 0; i < data.length; i++) {
					var publishArr = ('' + data[i]['publish_date']).split(' ')[0].split('-');
					updates.push({
						title: data[i]['title'],
						publish_date:
							publishArr[2] +
							' ' +
							monthNames[parseInt(publishArr[1]) - 1] +
							' ' +
							publishArr[0],
						short_content: data[i]['short_content'],
						id: data[i]['id'],
					});
					if (!data[i]['quick_seen_at']) {
						unseen_ids.push(data[i]['id']);
					}
				}
				if (unseen_ids.length > 0) {
					Bark.api(
						'seller-comms/updates/read/',
						{
							update_ids: unseen_ids,
							read_type: 'quick_seen',
						},
						function () {},
						function (err) {
							console.error(err);
						},
						'POST',
						Bark.apiVersionHeader('v2'),
					);
				}
				return {
					updates: updates,
				};
			},
		);
	}

	function homeUpdatesUnread() {
		processTemplate(
			$('.js-updates-count'),
			'hbt-home-updates-count',
			'seller-comms/updates/read/',
			function (data) {
				return {
					show: data.data.count_short_unseen > 0,
					count:
						data.data.count_short_unseen > 0
							? '&bull;'
							: data.data.count_short_unseen + '',
				};
			},
		);
	}

	function profileCompleteness() {
		processTemplate(
			$('.js-profile-completeness'),
			'hbt-profile-completeness',
			'seller/profile/progress',
			function (data) {
				return {
					percent: data.percent,
				};
			},
		);
	}

	function expandingHeaderListener() {
		var debounce = false;
		var dismissed = !$('.js-expander').hasClass('tbd');
		$('.js-expander-header').click(function () {
			if (debounce) {
				return;
			}
			debounce = true;
			var expander = $(this).closest('.js-expander');
			expander.find('.js-expander-content').slideToggle(1000);
			expander.toggleClass('expanded');
			setTimeout(function () {
				debounce = false;
				if (!dismissed && expander.hasClass('tbd')) {
					var payload = { type: 'seller-dashboard-intro-visible' };
					Bark.api(
						'/banner/dismiss/',
						payload,
						function (data) {
							if (data.status) {
								dismissed = true;
								expander.removeClass('tbd');
							}
						},
						function () {},
						'POST',
						Bark.apiVersionHeader('v2'),
					);
				}
			}, 1000);
		});
		$('.seller-home-video-container .play-icon').click(function (e) {
			e.preventDefault();

			if ($('.seller-home-video-container').hasClass('playing')) {
				$('.seller-home-video-container').removeClass('playing');
				$('.seller-home-video-container video').get(0).pause();
			} else {
				$('.seller-home-video-container').addClass('playing');
				$('.seller-home-video-container video').get(0).play();
			}
		});

		$('.secondary-hider').on('click', function (e) {
			e.preventDefault();
			$('.js-expander-header').click();
		});
	}

	function getGreetingTime(m) {
		var g = null; //return g

		if (!m || !m.isValid()) {
			return;
		} //if we can't find a valid or filled moment, we return.

		var split_too_early = 4; //24hr time to split the afternoon
		var split_morning = 12; //24hr time to split the afternoon
		var split_afternoon = 18; //24hr time to split the evening
		var split_evening = 22; //24hr time to split the evening
		var currentHour = parseFloat(m.format('HH'));

		if (currentHour < split_too_early) {
			g = _t('seller_homepage:greetings.generic');
		} else if (currentHour < split_morning) {
			g = _t('seller_homepage:greetings.good-morning');
		} else if (currentHour < split_afternoon) {
			g = _t('seller_homepage:greetings.good-afternoon');
		} else if (currentHour < split_evening) {
			g = _t('seller_homepage:greetings.good-evening');
		} else {
			g = _t('seller_homepage:greetings.generic');
		}

		return g;
	}

	function momentInit() {
		try {

			$('.js-moment-time-now').text(moment().format('dddd, D MMM h:mma').capitalize());
			var greeting = $('.js-moment-greeting');
			greeting.text(greeting.text().replace('Hello, ', getGreetingTime(moment()) + ', '));
		} catch (err) {}
		$('.js-welcome-container').css('opacity', 1.0);
	}

	momentInit();

	homeLeadsStatus();
	homeResponsesStatus();
	profileCompleteness();
    document.querySelector('#hbt-home-updates-short')?.length && homeUpdatesLatest();
    homeUpdatesUnread();
    expandingHeaderListener();

    handleSignupMessages();
}

function init() {
	if ($('.js-seller-home').length > 0) {
		LegacyHomePage();
		var alt = '';
		$('.avatar-container img.default-avatar').on('error', function () {
			$(this).parent().find('div.default-avatar').removeClass('d-none');
			$(this).parent().find('div.default-avatar').addClass('d-inline-flex');
			$(this).addClass('d-none');
			if (alt !== $(this).prop('alt')) {
				alt = $(this).prop('alt');
				bugsnagClient.notify(new Error('seller-profile-image:failed'), {
					metaData: { 'alt-text': alt, location: 'header' },
					severity: 'info',
				});
			}
		});
		$('.avatar-container img.default-avatar').each(function () {
			if (
				$(this).hasClass('error') ||
				($(this).get()[0].complete &&
					$(this).get()[0].naturalWidth === 0 &&
					$(this).get()[0].naturalHeight === 0)
			) {
				$(this).trigger('error', 'dnr');
			}
		});

        triggerEnquiriesBanner({
            pagename: window.location.pathname
        })
	}
}
